module.exports = __webpack_public_path__ + "img/NoiseAware_Logo_Bug_Green.557d532f.svg";